export default __webpack_public_path__ + "static/media/Z_s.c7e5af65.jpg";